// extracted by mini-css-extract-plugin
export default {"codeOfConduct":"xr9ywPCOwVwBuQJvNPmo"};